import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Customer } from '../data/types';

interface CustomerHistoryContextType {
  selectedCustomer: Customer | null;
  setSelectedCustomer: (customer: Customer | null) => void;
}

const CustomerHistoryContext = createContext<CustomerHistoryContextType | undefined>(undefined);

export function CustomerHistoryProvider({ children }: { children: ReactNode }) {
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);

  return (
    <CustomerHistoryContext.Provider value={{ selectedCustomer, setSelectedCustomer }}>
      {children}
    </CustomerHistoryContext.Provider>
  );
}

export function useCustomerHistory() {
  const context = useContext(CustomerHistoryContext);
  if (context === undefined) {
    throw new Error('useCustomerHistory must be used within a CustomerHistoryProvider');
  }
  return context;
}